<template>
	<div class="home ai">

		<div class="aiCon">
			<div class="aiCon_gb" @click="close"><img src="@/assets/img/icon5.png" /></div>
			<div class="aiCon_a" id="myDivs" :class="isScrollPd ? 'aiCon_a_gdt' : 'aiCon_a_gdt'">
				<div class="aiCon_a_li" :class="item.type == 1 ? 'aiCon_a_li_br' : ''" v-for="(item, index) in aiLists"
					:key="index">
					<div class="aiCon_a_li_t">
						<img :src="userInfo.avatar" v-if="item.type == 1" class="aiCon_a_li_l" />
						<img src="@/assets/img/icon38.png" v-else class="aiCon_a_li_l" />
						<div class="aiCon_a_li_r">
							<div class="aiCon_a_li_r_con">{{ item.content }}<img :src="item.img" /></div>
						</div>
					</div>
					<div class="aiCon_b" v-if="item.type == 0">
						<div @click="againHandle(index)"><img src="@/assets/img/icon39.png" /></div>
						<div @click="copyHandle(item.content)"><img src="@/assets/img/icon40.png" /></div>
					</div>
				</div>
			</div>

			<div class="aiCon_c">
				<div class="aiCon_c_l"><input type="text" v-model="content"
						placeholder="The advantages of Artificial Intelligence" /><img src="@/assets/img/icon41.png" />
				</div>
				<div class="aiCon_c_r" @click="submit">Submit</div>
			</div>
		</div>

	</div>
</template>

<script>
// @ is an alias to /src
import { chat } from '@/api/user'
import bottomNav from '@/components/bottomNav.vue'
import topNav from '@/components/topNav.vue'
export default {
	name: 'HomeView',
	components: {
		topNav,
		bottomNav
	},
	data() {
		return {
			screenWidth: 0,
			aiLists: [

			],//type=1 本人  type=0 ai回复
			isScrollPd: false,//判断是否有滚动条
			content: '',
			isSubmit: true,
			lastContent: '',
			userInfo:localStorage.getItem('userInfo')?JSON.parse(localStorage.getItem('userInfo')):{}
		}
	},
	mounted() {
		var that = this;
		this.$nextTick(() => {
			setTimeout(function () {
				that.isScroll();//判断是否有滚动条
			}, 300)

		})
	},
	created() {
		this.screenWidth = window.innerWidth;
		window.addEventListener('resize', this.handleResize);
		this.$nextTick(() => {
			document.body.style = 'background: linear-gradient(180deg, rgba(209, 231, 255, 1) 0%, rgba(240, 247, 255, 1) 19.61%, rgba(250, 250, 250, 1) 100%);';
		})

	},
	beforeDestroy() {
		document.body.style.backgroundColor = '';
	},
	methods: {
		//判断是否有滚动条
		isScroll() {
			var divElement = document.getElementById("myDivs");
			divElement.offsetHeight < divElement.scrollHeight ? this.isScrollPd = true : this.isScrollPd = false
			divElement.scrollTop = divElement.scrollHeight;
			/*if (divElement.offsetHeight < divElement.scrollHeight) {
			  console.log("Div has a vertical scrollbar，有");
			} else {
			  console.log("Div does not have a vertical scrollbar，无");
			}*/
		},
		goRouter(e) {
			this.$router.push(e);
		},
		handleResize() {
			this.screenWidth = window.innerWidth;
		},
		close() {
			this.$emit('closeHandle')
		},
		submit() {
			if (this.isSubmit) {
				if (this.content == '') {
					return this.$message.error('Please enter the content');
				} else {
					this.aiLists.push({ content: this.content, type: 1, id: this.aiLists.length })
					this.isSubmit = false;
					chat({ content: this.content }).then(res => {
						console.log('res', res);
						if (res.code == 1) {
							this.isSubmit = true;
							this.content = ''
							this.aiLists.push({ content: res.data.massage, type: 0, id: this.aiLists.length })
						}
					})
				}
			} else {
				return this.$message.error('Generating, please try again later');
			}
		},
		againHandle(e) {
			let text = this.aiLists[e - 1].content;
			if (this.isSubmit) {
				this.aiLists.push({ content: text, type: 1, id: this.aiLists.length })
				this.isSubmit = false;
				chat({ content: text }).then(res => {
					if (res.code == 1) {
						this.isSubmit = true;
						this.aiLists.push({ content: res.data.massage, type: 0, id: this.aiLists.length })
					}
				})
			} else {
				return this.$message.error('Generating, please try again later');
			}
		},
		async copyHandle(e) {
			await navigator.clipboard.writeText(e);
			this.$message.success('Successfully copied');
		}
	}
}
</script>
<style>
/* body,html{background:#F5F5F5;} */
</style>
